/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import axios from 'axios';
import {
  Button,
  CardBody,
  Table,
  FormGroup,
  Col,
  Label,
  Input,
  Container,
  Row,
  Alert,
} from 'reactstrap';
import Swal from 'sweetalert2';
import moment from 'moment';
import ManageMatchingCriteria from '../../../components/GenericDocuments/ManageMatchingCriteria';
import apiResponseHandler from '../../../utils/apiResponseHandler';
import { environment } from '../../../environment/environment';
import EditEmployerPayrollForm from './EditEmployerPayrollForm';
import AddEmployerPayrollModal from './AddEmployerPayrollModal';
import Branches from '../Branches';
import SubscriptionsTable from './SubscriptionsTable';
import TransactionFeesTable from './TransactionFeesTable';
import FlaggedButton from '../../../components/FlaggedButton';
import ManageMultipleMatchingCriterias from '../../../components/GenericDocuments/ManageMultipleMatchingCriterias';
import ManageWhitelabelModal from './ManageWhitelabelModal';
import { taConfigApiService } from '../../../services/TaConfigApiService';
import CollapsibleCard from '../../../components/CollapsibleCard';
import EmployerFeaturesCard from './EmployerFeaturesCard';

const TIME_AND_ATTENDANCE = 'Time and Attendance';
const IRP5S = 'IRP5s';

class EmployerDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      loadingJob: false,
      embeddedSignupJob: {},
      jobFetchError: null,
      save_data: {},
      errors: [],
      formError: false,
      triedSubmitting: true,
      showEditModal: false,
      showAddPayrollModal: false,
      showManageWhitelabelModal: false,
      activePayroll: null,
      allowApplyAll: true,
      subscriptions: [],
      employerFeatures: [],
      _protectedPayslip: {},
      taConfig: { whatsapp_reminders: true, phone_call_reminders: false },
      taConfigLoading: false,
    };
  }

  componentDidMount() {
    this.getEmployerData();
    this.getEmployerFeatures();
  }

  static getDay(number) {
    switch (number) {
      case 0:
        return 'Sunday';
      case 1:
        return 'Monday';
      case 2:
        return 'Tuesday';
      case 3:
        return 'Wednesday';
      case 4:
        return 'Thursday';
      case 5:
        return 'Friday';
      case 6:
        return 'Saturday';
      default:
        return 'Cannot determine day';
    }
  }

  getEmployerData = () => {
    this.setState({ loading: true });
    axios
      .get(`${environment.baseUrl}/employers/${this.props.match.params.empId}/`)
      .then((res) => {
        this.setState(() => ({
          ...res.data,
          save_data: res.data,
          loading: false,
        }));
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  getEmployerFeatures = () => {
    return axios
      .get(
        `${environment.baseUrl}/employer_features/?employer_id=${this.props.match.params.empId}`,
      )
      .then((res) => {
        this.setState({ employerFeatures: res.data });
        this.fetchTaConfig();
      })
      .catch((err) => {
        apiResponseHandler.handleApiError('Failed to refresh employer features', err);
      });
  };

  getEmbeddedSignupJob = () => {
    this.setState({ loadingJob: true });
    axios
      .get(`${environment.baseUrl}/whatsapp_embedded_signup_jobs/job_by_employer_id/?employer_id=${this.props.match.params.empId}`)
      .then((res) => {
        this.setState(() => ({
          embeddedSignupJob: res.data,
          loadingJob: false,
        }));
      })
      .catch((error) => {
        this.setState({
          loadingJob: false,
          embeddedSignupJob: {}
        });
        // Optionally show user notification
        apiResponseHandler.handleApiError('Failed to fetch whitelabel job data', error);
      });
  };

  fetchTaConfig = () => {
    const employerId = this.props.match.params.empId;
    this.setState({ taConfigLoading: true });
    taConfigApiService.get(employerId)
      .then((data) => {
        this.setState({ taConfig: data, taConfigLoading: false });
      })
      .catch(() => {
        this.setState({ taConfigLoading: false });
      });
  };

  updateTaConfig = (config) => {
    if (this.state.taConfigLoading) return;

    // Phone calls require WhatsApp — force off when WhatsApp is disabled
    if (!config.whatsapp_reminders) {
      config.phone_call_reminders = false;
    }

    const employerId = this.props.match.params.empId;
    this.setState({ taConfigLoading: true });
    taConfigApiService.update(employerId, config)
      .then((data) => {
        this.setState({ taConfig: data, taConfigLoading: false });
        Swal.fire('Success', 'Time & Attendance configuration updated', 'success');
      })
      .catch((err) => {
        this.setState({ taConfigLoading: false });
        apiResponseHandler.handleApiError(err);
      });
  };

  /**
   * Archive an employer pay cycle.
   * Shows a confirmation dialog before proceeding. The pay cycle is soft-archived rather than permanently deleted.
   *
   * @param {int} payRollId
   *
   */
  deletePayRoll = (payRollId) => {
    Swal.fire({
      title: 'Archive this pay cycle?',
      text: 'This pay cycle will be archived and hidden from the active list. This cannot be undone from Admin.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, archive it',
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ loading: true });
        axios
          .delete(`${environment.baseUrl}/pay_cycles/${payRollId}/`)
          .then(() => {
            Swal.fire({ title: 'Pay cycle archived.', icon: 'success' });
            this.getEmployerData();
          })
          .catch((error) => {
            apiResponseHandler.handleApiError('Cannot archive pay cycle', error);
            this.setState({ loading: false });
          });
      }
    });
  };

  handleShowEditPayrollModal = (payCycle) => {
    this.setState({ activePayroll: payCycle }, () =>
      this.setState({ showEditModal: true }),
    );
  };

  handleShowAddPayrollModal = () => {
    this.setState({ showAddPayrollModal: true });
  };

  handleShowManageWhitelabelModal = () => {
    this.setState({ showManageWhitelabelModal: true });
    this.getEmbeddedSignupJob();
  };

  applyAction = (action, description) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `Are you sure you want to ${description}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, do it!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        const { save_data } = this.state;

        await axios.patch(
          `${environment.baseUrl}/employers/${this.props.match.params.empId}/`,
          {
            ...save_data,
          },
        );
        axios
          .post(
            `${environment.baseUrl}/employers/${this.props.match.params.empId}/${action}/`,
          )
          .then(() => {
            Swal.fire({
              title: 'Action was successful',
              icon: 'success',
            });
          })
          .catch((error) => {
            apiResponseHandler.handleApiError('Error', error);
          });
      }
    });
  };

  validateInputs = (data) => {
    const errors = [];

    if (data?.company_name?.trim() === '' || data?.company_name === undefined) {
      errors.push('Company Name is a required field.');
    }

    if (!data?.default_risk_metric || data?.default_risk_metric === undefined) {
      errors.push('Default Risk Metric is a required field.');
    }

    this.setState((prevState) => ({
      ...prevState,
      errors,
      formError: errors.length > 0,
      triedSubmitting: true,
    }));

    return errors.length < 1;
  };

  saveData = () => {
    if (this.validateInputs(this.state.save_data)) {
      axios
        .patch(
          `${environment.baseUrl}/employers/${this.props.match.params.empId}/`,
          {
            ...this.state.save_data,
          },
        )
        .then(() => {
          Swal.fire({
            title: 'Employer profile saved',
            icon: 'success',
            toast: true,
            position: 'top',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.setState({ allowApplyAll: true });
        })
        .catch((error) => {
          apiResponseHandler.handleApiError('Error', error);
        });
    }
  };

  toggle = () => {
    this.getEmployerData();
    this.setState((prevState) => ({
      showEditModal: !prevState.showEditModal,
    }));
  };

  toggleAdvanceApproval = (e) => {
    this.setState((prevState) => ({
      save_data: {
        ...prevState.save_data,
        advances_require_approval: e.target.checked,
      },
    }));
  };

  toggleAutoSendOnboardingSms = (e) => {
    const { checked } = e.target;
    this.setState(
      (prevState) => ({
        save_data: {
          ...prevState.save_data,
          auto_send_onboarding_sms: checked,
        },
      }),
      () => this.saveData(),
    );
  };

  renderOnboardingSmsCard = () => {
    const { save_data, company_name } = this.state;
    return (
      <Row>
        <Col>
          <CollapsibleCard title="Onboarding SMS">
            <CardBody>
              <div className="d-flex justify-content-end py-2">
                <button
                  onClick={() =>
                    this.applyAction(
                      'sendOnboardingSms',
                      `send an onboarding sms to all employees of ${company_name}`,
                    )
                  }
                  className="btn btn-primary btn-sm"
                >
                  Send SMS
                </button>
              </div>
              <Row>
                <Col lg={10}>Auto-send onboarding SMS on employee import</Col>
                <Col lg={1}>
                  <Input
                    onChange={this.toggleAutoSendOnboardingSms}
                    type="checkbox"
                    checked={save_data.auto_send_onboarding_sms || false}
                  />
                </Col>
              </Row>
            </CardBody>
          </CollapsibleCard>
        </Col>
      </Row>
    );
  };

  toggleAddPayrollModal = () =>
    this.setState((prevState) => ({
      showAddPayrollModal: !prevState.showAddPayrollModal,
    }));

  handlePayCycleCreated = (newPayCycle) =>
    this.setState((prevState) => ({
      showAddPayrollModal: false,
      save_data: {
        ...prevState.save_data,
        pay_cycles: [...(prevState.save_data.pay_cycles || []), newPayCycle],
      },
    }));

  toggleManageWhitelabelModal = () =>
    this.setState((prevState) => ({
      showManageWhitelabelModal: !prevState.showManageWhitelabelModal,
    }));

  handleinputchange = (event) => {
    this.setState({
      save_data: {
        ...this.state.save_data,
        [event.target.name]: event.target.value,
      },
      allowApplyAll: false,
    });
  };

  deleteEmployer = () => {
    Swal.fire({
      title: `Deleting ${this.state.company_name}?`,
      text: `All the Pending Advances will be rejected, and All ODP features for ${this.state.company_name} will be disabled
      `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${environment.baseUrl}/employers/${this.props.match.params.empId}/delete_employer/`,
          )
          .then(() => {
            Swal.fire({
              title: `Employer ${this.state.company_name} deleted `,
              icon: 'success',
            });

            this.props.history.push('/admin/employers');
          })
          .catch((error) => {
            apiResponseHandler.handleApiError('Error', error);
          });
      }
    });
  };

  renderPayrollRow = (pay_cycle) => (
    <tr key={`payroll_${pay_cycle.id}`}>
      <td>
        {pay_cycle.name}{' '}
        {pay_cycle.is_default && (
          <span className="badge badge-success">Default</span>
        )}
        {pay_cycle.enable_custom_cutoff_date &&
          Date.parse(pay_cycle.advance_cut_off_date) < Date.now() && (
            <span className="badge badge-warning">Custom cutoff</span>
          )}
      </td>
      <td>{pay_cycle.id}</td>
      <td>
        {pay_cycle.frequency === 'monthly' &&
          pay_cycle.frequency_type === 'day based' &&
          `Monthly, on the ${pay_cycle.pay_day_position === 0 ? 'first' : 'last'} ${EmployerDetail.getDay(pay_cycle.pay_day)}`}
        {pay_cycle.frequency === 'monthly' &&
          pay_cycle.frequency_type === 'date based' &&
          `Monthly, on the ${pay_cycle.pay_date}`}
        {pay_cycle.frequency === 'weekly' &&
          pay_cycle.frequency_type === 'day based' &&
          `Weekly, on a ${EmployerDetail.getDay(pay_cycle.pay_day)}`}
        {pay_cycle.frequency === 'fortnightly' &&
          pay_cycle.frequency_type === 'day based' &&
          `Fortnightly, starting on the ${moment(pay_cycle.initial_pay_date).format('Do MMMM YYYY')}`}
      </td>
      <td>{pay_cycle.cut_off_days}</td>
      <td>
        <div className="d-flex flex-nowrap justify-content-end">
          <button
            onClick={() => this.handleShowEditPayrollModal(pay_cycle)}
            className="btn btn-primary btn-sm"
          >
            Edit
          </button>
          <button
            onClick={() => this.deletePayRoll(pay_cycle.id)}
            className="btn btn-danger btn-sm"
            style={{ marginLeft: '4px' }}
          >
            Archive
          </button>
        </div>
      </td>
    </tr>
  );

  renderPayrollBody = () => {
    const { save_data } = this.state;
    return (
      <Table responsive striped size="sm">
        <thead>
          <tr>
            <th>Name</th>
            <th>ID</th>
            <th>Description</th>
            <th>Cut off</th>
          </tr>
        </thead>
        <tbody>
          {!!save_data.pay_cycles &&
            save_data.pay_cycles.map((pay_cycle) =>
              this.renderPayrollRow(pay_cycle),
            )}
        </tbody>
      </Table>
    );
  };

  renderPayrollCard = () => (
    <CollapsibleCard title="Employer Payrolls" className="shadow">
      <div className="d-flex justify-content-end px-3 py-2">
        <Button
          color="primary"
          onClick={() => this.handleShowAddPayrollModal()}
          className="btn btn-primary btn-sm"
        >
          New Payroll
        </Button>
      </div>
      {this.renderPayrollBody()}
    </CollapsibleCard>
  );

  renderJemMobileConfig = () => {
    const { save_data } = this.state;
    return (
      <Row>
        <Col lg={12} className="font-weight-bold">Jem Mobile</Col>
        <Col lg={6}>
          <FormGroup>
            <label htmlFor="jem_mobile_minimum_duration_device">
              Min. employment months (Devices)
            </label>
            <Input
              type="number"
              name="jem_mobile_minimum_duration_device"
              id="jem_mobile_minimum_duration_device"
              value={save_data.jem_mobile_minimum_duration_device ?? ''}
              onChange={this.handleinputchange}
              className="form-control"
              style={{ maxWidth: '10rem' }}
              placeholder="Not set"
              min="0"
            />
            <small className="text-muted">Leave empty = no employer gate. 0 = any tenure passes.</small>
          </FormGroup>
        </Col>
        <Col lg={6}>
          <FormGroup>
            <label htmlFor="jem_mobile_minimum_duration_data">
              Min. employment months (Data)
            </label>
            <Input
              type="number"
              name="jem_mobile_minimum_duration_data"
              id="jem_mobile_minimum_duration_data"
              value={save_data.jem_mobile_minimum_duration_data ?? ''}
              onChange={this.handleinputchange}
              className="form-control"
              style={{ maxWidth: '10rem' }}
              placeholder="Not set"
              min="0"
            />
            <small className="text-muted">Leave empty = no employer gate. 0 = any tenure passes.</small>
          </FormGroup>
        </Col>
      </Row>
    );
  };

  render() {
    const {
      loading,
      save_data,
      company_name,
      allowApplyAll,
      employerFeatures,
    } = this.state;

    const hasIRP5s = employerFeatures?.some((f) => f.name === IRP5S && f.enabled);

    return (
      <section className="dashboard">
        <div className="header bg-primary">
          <Container fluid>
            <div className="header-body">
              <Row className="align-items-center py-4">
                <Col lg="6">
                  <h6 className="h2 text-white d-inline-block mb-0">
                    {company_name}
                  </h6>
                </Col>
                <Col className="d-flex justify-content-end">
                  <FlaggedButton
                    type="button"
                    className="btn btn-white btn-md"
                    flag="ADMIN_PORTAL_MANAGE_WHITELABEL_FEATURE_FLAG_TEMP"
                    onClick={this.handleShowManageWhitelabelModal}
                  >
                    Manage Whitelabel
                  </FlaggedButton>
                  <Button
                    color="warning"
                    type="button"
                    size="md"
                    onClick={() =>
                      this.props.history.push({
                        pathname: `/admin/employers/${this.props.match.params.empId}/recons`,
                        state: {
                          company_name,
                          save_data,
                        },
                      })
                    }
                  >
                    Manage Recons
                  </Button>

                  <FlaggedButton
                    flag="ADMIN_PORTAL_DELETE_EMPLOYER_FEATURE_FLAG_TEMP"
                    className="btn btn-danger btn-md"
                    type="button"
                    onClick={() => this.deleteEmployer()}
                  >
                    Delete
                  </FlaggedButton>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
        <Container fluid>
          <Row className="pt-2">
            {loading ? (
              <Row className="my-3">
                <Col className="d-flex justify-content-center">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </Col>
              </Row>
            ) : (
              <>
                <Col lg={8}>
                  <EmployerFeaturesCard
                    employerId={this.props.match.params.empId}
                    features={employerFeatures}
                    onSaveSuccess={this.getEmployerFeatures}
                  />
                  <Row className="mb-4">
                    <Col>
                      {this.renderPayrollCard()}
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Col>
                      <SubscriptionsTable
                        employerId={this.props.match.params.empId}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Col>
                      <TransactionFeesTable
                        employerId={this.props.match.params.empId}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Col>
                      <Branches
                        branches={save_data.branches}
                        employerId={this.props.match.params.empId}
                        getEmployerData={this.getEmployerData}
                      />
                    </Col>
                  </Row>
                  {this.renderOnboardingSmsCard()}
                </Col>
                <Col lg={4}>
                  {this.state.formError && this.state.errors && (
                    <Alert color="danger">
                      {this.state.errors.map((error) => (
                        <li key={error}>{error}</li>
                      ))}
                    </Alert>
                  )}
                  <CollapsibleCard title="Employer Settings" className="shadow" defaultCollapsed={false}>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <FormGroup>
                            <label
                              htmlFor="company_name"
                              className="required-input"
                            >
                              Company name
                            </label>
                            <Input
                              type="text"
                              id="company_name"
                              name="company_name"
                              value={save_data.company_name}
                              onChange={this.handleinputchange}
                              className="form-control"
                              placeholder="Company name"
                              invalid={
                                this.state.triedSubmitting &&
                                !this.state.save_data?.company_name?.trim()
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={12}>
                          <FormGroup>
                            <label htmlFor="brand_name">
                              Brand name
                            </label>
                            <Input
                              type="text"
                              id="brand_name"
                              name="brand_name"
                              value={save_data.brand_name ?? ''}
                              onChange={this.handleinputchange}
                              className="form-control"
                              placeholder="Brand name"
                              maxLength={255}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={12} className="font-weight-bold">Approvals</Col>
                        <Col lg={10}>Advances Require Approval</Col>
                        <Col lg={1}>
                          <Input
                            onChange={this.toggleAdvanceApproval}
                            type="checkbox"
                            checked={save_data.advances_require_approval}
                          />{' '}
                        </Col>
                      </Row>
                      <hr />
                      <Row>
                        <Col lg={12}>
                          <FormGroup>
                            <label
                              htmlFor="fee_value"
                              className="required-input"
                            >
                              Default risk metric
                            </label>
                            <div className="input-group">
                              <Input
                                type="number"
                                name="default_risk_metric"
                                value={save_data.default_risk_metric}
                                onChange={this.handleinputchange}
                                className="form-control"
                                style={{ maxWidth: '10rem' }}
                                placeholder="Risk metric"
                                invalid={
                                  this.state.triedSubmitting &&
                                  !this.state.save_data?.default_risk_metric &&
                                  this.state.save_data?.default_risk_metric !==
                                  0
                                }
                              />
                              <div className="input-group-append">
                                <span className="input-group-text">%</span>
                              </div>
                            </div>
                            <br />

                            <Button
                              className="btn btn-block"
                              color={allowApplyAll ? 'info' : 'secondary'}
                              disabled={!allowApplyAll}
                              onClick={() =>
                                this.applyAction(
                                  'applyDefaultRiskMetric',
                                  `apply default risk metric to all the employees of ${company_name}`,
                                )
                              }
                            >
                              {allowApplyAll
                                ? 'Apply default risk metric to all employees'
                                : 'Press save changes to enable this button'}
                            </Button>
                          </FormGroup>
                        </Col>
                      </Row>
                      <hr />
                      {this.renderJemMobileConfig()}
                      <hr />
                      <Row>
                        <Col lg={12}>
                          <FormGroup>
                            <Label for="defaultPayRoll">Default payroll</Label>

                            <Input
                              type="select"
                              name="defaultPayRoll"
                              id="defaultPayRoll"
                              onChange={(e) => this.handleinputchange(e)}
                              value={save_data.defaultPayRoll || ''}
                              required
                            >
                              {!!save_data.pay_cycles &&
                                save_data.pay_cycles.map((pay_cycle) => (
                                  <option
                                    value={pay_cycle.id}
                                    key={pay_cycle.id}
                                  >
                                    {pay_cycle.name}
                                  </option>
                                ))}
                            </Input>
                            <br />

                            <Button
                              className="btn btn-block"
                              color={allowApplyAll ? 'info' : 'secondary'}
                              disabled={!allowApplyAll}
                              onClick={() =>
                                this.applyAction(
                                  'applyDefaultPayroll',
                                  `apply the default payroll to all the employees of ${company_name}`,
                                )
                              }
                            >
                              {allowApplyAll
                                ? 'Apply default payroll to all employees'
                                : 'Press save changes to enable this button'}
                            </Button>
                          </FormGroup>
                        </Col>
                      </Row>
                      <hr />

                      <Row>
                        <Col>
                          <button
                            onClick={this.saveData}
                            className="btn btn-primary btn-block"
                          >
                            Save changes
                          </button>
                        </Col>
                      </Row>
                    </CardBody>
                  </CollapsibleCard>
                  {this.props.match.params.empId && (
                    <ManageMatchingCriteria
                      documentType="Payslips"
                      employerId={this.props.match.params.empId}
                    />
                  )}
                  {this.props.match.params.empId && hasIRP5s && (
                    <ManageMatchingCriteria
                      documentType={IRP5S}
                      employerId={this.props.match.params.empId}
                    />
                  )}
                  {!loading && this.props.match.params.empId && employerFeatures && employerFeatures
                    .filter((f) => (f.name === 'Rosters' && f.enabled) || (f.name === 'Timesheets' && f.enabled)).length > 0 && (
                      <ManageMultipleMatchingCriterias
                        employerId={this.props.match.params.empId}
                        features={employerFeatures.filter((f) => (f.name === 'Rosters' && f.enabled) || (f.name === 'Timesheets' && f.enabled))}
                        title={employerFeatures.filter((f) => (f.name === 'Rosters' && f.enabled) || (f.name === 'Timesheets' && f.enabled)).map((f) => f.name).join(', ').replace(/, ([^,]*)$/, ' & $1')}
                      />
                    )}
                  {!loading && this.props.match.params.empId && employerFeatures &&
                    employerFeatures.some((f) => f.name === TIME_AND_ATTENDANCE && f.enabled) && (
                      <CollapsibleCard title="Time & Attendance Configuration" className="mt-3">
                            <CardBody>
                              <Row>
                                <Col md="6">
                                  <FormGroup check>
                                    <Label check>
                                      <Input
                                        type="checkbox"
                                        checked={this.state.taConfig.whatsapp_reminders}
                                        disabled={this.state.taConfigLoading}
                                        onChange={(e) => this.updateTaConfig({
                                          ...this.state.taConfig, whatsapp_reminders: e.target.checked
                                        })}
                                      />
                                      {' '}WhatsApp Reminders
                                    </Label>
                                    <p className="text-muted small mt-1">
                                      Master switch for all WhatsApp shift messages. When off, no WhatsApp is sent regardless of the granular toggles below.
                                    </p>
                                  </FormGroup>
                                  <div className="ms-4">
                                    <FormGroup check className="mt-2">
                                      <Label check>
                                        <Input
                                          type="checkbox"
                                          checked={this.state.taConfig.enable_shift_reminder !== false}
                                          disabled={this.state.taConfigLoading || !this.state.taConfig.whatsapp_reminders}
                                          onChange={(e) => this.updateTaConfig({
                                            ...this.state.taConfig, enable_shift_reminder: e.target.checked
                                          })}
                                        />
                                        {' '}Pre-shift Reminder
                                      </Label>
                                      <p className="text-muted small mt-1">
                                        Send a WhatsApp nudge ahead of each shift starting.
                                      </p>
                                    </FormGroup>
                                    <FormGroup check className="mt-2">
                                      <Label check>
                                        <Input
                                          type="checkbox"
                                          checked={this.state.taConfig.enable_followup_reminders !== false}
                                          disabled={this.state.taConfigLoading || !this.state.taConfig.whatsapp_reminders}
                                          onChange={(e) => this.updateTaConfig({
                                            ...this.state.taConfig, enable_followup_reminders: e.target.checked
                                          })}
                                        />
                                        {' '}Follow-up Reminders
                                      </Label>
                                      <p className="text-muted small mt-1">
                                        Check in via WhatsApp when an employee hasn't clocked in after the grace period.
                                      </p>
                                    </FormGroup>
                                    <FormGroup check className="mt-2">
                                      <Label check>
                                        <Input
                                          type="checkbox"
                                          checked={this.state.taConfig.enable_clockout_reminders !== false}
                                          disabled={this.state.taConfigLoading || !this.state.taConfig.whatsapp_reminders}
                                          onChange={(e) => this.updateTaConfig({
                                            ...this.state.taConfig, enable_clockout_reminders: e.target.checked
                                          })}
                                        />
                                        {' '}Clock-out Reminders
                                      </Label>
                                      <p className="text-muted small mt-1">
                                        Remind employees to clock out near the end of their shift, and follow up if they haven't.
                                      </p>
                                    </FormGroup>
                                    <FormGroup check className="mt-2">
                                      <Label check>
                                        <Input
                                          type="checkbox"
                                          checked={this.state.taConfig.enable_no_clockin_digest === true}
                                          disabled={this.state.taConfigLoading || !this.state.taConfig.whatsapp_reminders}
                                          onChange={(e) => this.updateTaConfig({
                                            ...this.state.taConfig, enable_no_clockin_digest: e.target.checked
                                          })}
                                        />
                                        {' '}No-clock-in Manager Digest
                                      </Label>
                                      <p className="text-muted small mt-1">
                                        Send managers a per-site WhatsApp digest of employees who haven&apos;t clocked in by the cutoff. Only managers individually opted in (on their user page) receive it.
                                      </p>
                                    </FormGroup>
                                  </div>
                                  <FormGroup check className="mt-3">
                                    <Label check>
                                      <Input
                                        type="checkbox"
                                        checked={this.state.taConfig.phone_call_reminders}
                                        disabled={this.state.taConfigLoading || !this.state.taConfig.whatsapp_reminders}
                                        onChange={(e) => this.updateTaConfig({
                                          ...this.state.taConfig, phone_call_reminders: e.target.checked
                                        })}
                                      />
                                      {' '}Phone Call Reminders
                                    </Label>
                                    <p className="text-muted small mt-1">
                                      Escalate to automated phone calls when employees don't respond to WhatsApp follow-ups.
                                    </p>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </CardBody>
                      </CollapsibleCard>
                    )}
                </Col>
              </>
            )}
          </Row>
        </Container>

        {
          !!this.state.activePayroll && this.state.showEditModal && (
            <EditEmployerPayrollForm
              key={this.state.activePayroll.id}
              toggle={this.toggle}
              showEditModal
              payrollName={this.state.activePayroll.name}
              isDefault={this.state.activePayroll.is_default}
              payrollId={this.state.activePayroll.id}
              enableCustomCutOffDate={
                this.state.activePayroll.enable_custom_cutoff_date
              }
              cutOffDays={this.state.activePayroll.cut_off_days}
              advanceReconDate={this.state.activePayroll.advance_recon_date}
              advanceCutOffDate={this.state.activePayroll.advance_cut_off_date}
            />
          )
        }

        {
          !!this.state.showAddPayrollModal && (
            <AddEmployerPayrollModal
              toggle={this.toggleAddPayrollModal}
              onPayCycleCreated={this.handlePayCycleCreated}
              employerId={this.props.match.params.empId}
              showAddPayrollModal={this.state.showAddPayrollModal}
            />
          )
        }

        {
          !!this.state.showManageWhitelabelModal && (
            <ManageWhitelabelModal
              toggle={this.toggleManageWhitelabelModal}
              showManageWhitelabelModal={this.state.showManageWhitelabelModal}
              embeddedSignupJob={this.state.embeddedSignupJob}
              loadingJob={this.state.loadingJob}
              employerId={this.props.match.params.empId}
            />
          )
        }
      </section>
    );
  }
}

export default EmployerDetail;
